import { endOfQuarter, isSameDay, startOfQuarter } from 'date-fns';

import { PlanungsinformationFromThemaRouter } from '../../../dtos.js';
import { getQuartalsForDateRange, type Quartal, quartal } from './getQuartalsForDateRange.js';

const printQuartalterminLabel = (label: string, chosenQuartal: Quartal, year?: number): string =>
  `${label} ${chosenQuartal}${year ? ' ' + String(year) : ''}`;

const printQuartaltermine = (planungsinformation: PlanungsinformationFromThemaRouter, chosenQuartal: Quartal) => {
  switch (chosenQuartal) {
    case quartal.Q1:
      return planungsinformation.geplanteTermineQ1?.toString();
    case quartal.Q2:
      return planungsinformation.geplanteTermineQ2?.toString();
    case quartal.Q3:
      return planungsinformation.geplanteTermineQ3?.toString();
    case quartal.Q4:
      return planungsinformation.geplanteTermineQ4?.toString();
  }
};

export const getQuartalTableRows = (planungsinformation: PlanungsinformationFromThemaRouter, label: string) => {
  const planungsbeginn = planungsinformation.planungszeitraum?.start ?? null;
  const planungsende = planungsinformation.planungszeitraum?.end ?? null;

  if (planungsbeginn === null || planungsende === null) {
    return [
      [printQuartalterminLabel(label, quartal.Q1), printQuartaltermine(planungsinformation, quartal.Q1)],
      [printQuartalterminLabel(label, quartal.Q2), printQuartaltermine(planungsinformation, quartal.Q2)],
      [printQuartalterminLabel(label, quartal.Q3), printQuartaltermine(planungsinformation, quartal.Q3)],
      [printQuartalterminLabel(label, quartal.Q4), printQuartaltermine(planungsinformation, quartal.Q4)],
    ];
  }

  const startOfQuarterForGivenStartDate = startOfQuarter(planungsbeginn);
  const endOfQuarterForGivenEndDate = endOfQuarter(planungsende);
  const isStartDateEqualQuarterStart = isSameDay(startOfQuarterForGivenStartDate, planungsbeginn);
  const isEndDateEqualQuarterEnd = isSameDay(endOfQuarterForGivenEndDate, planungsende);

  if (!isStartDateEqualQuarterStart || !isEndDateEqualQuarterEnd) {
    return [
      [printQuartalterminLabel(label, quartal.Q1), printQuartaltermine(planungsinformation, quartal.Q1)],
      [printQuartalterminLabel(label, quartal.Q2), printQuartaltermine(planungsinformation, quartal.Q2)],
      [printQuartalterminLabel(label, quartal.Q3), printQuartaltermine(planungsinformation, quartal.Q3)],
      [printQuartalterminLabel(label, quartal.Q4), printQuartaltermine(planungsinformation, quartal.Q4)],
    ];
  }

  const quartalsList = getQuartalsForDateRange(planungsbeginn, planungsende);

  return quartalsList.map((listItem) => [
    printQuartalterminLabel(label, listItem.quartal, listItem.year),
    printQuartaltermine(planungsinformation, listItem.quartal),
  ]);
};
